import React, { useState } from 'react';
import './InfoBanner.css';
import { logBannerClose } from '../utils/analytics';

const InfoBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
    logBannerClose();
  };

  if (!isVisible) return null;

  return (
    <div className="info-banner">
      <div className="banner-content">
        <div className="marquee-container">
          <div className="marquee">
            <span className="marquee-text">
              📢 Welcome to LNMIIT Placement Tracker 2025-26!  &nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;  
              ⚠️ Off campus data is incomplete, use suggest button below to make it perfect!  &nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;  
            </span>
            <span className="marquee-text">
              📢 Welcome to LNMIIT Placement Tracker 2025-26!  &nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;  
              ⚠️ Off campus data is incomplete, use suggest button below to make it perfect!  &nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;  
            </span>
          </div>
        </div>
        
        <button 
          className="banner-close-btn" 
          onClick={handleClose}
          aria-label="Close banner"
        >
          <svg 
            className="close-icon"
            width="20" 
            height="20" 
            viewBox="0 0 20 20" 
            fill="none"
          >
            <path 
              d="M5 5L15 15M5 15L15 5" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default InfoBanner;
